import { styled } from 'common/src/designSystem/components/stitches';

export const FieldSpacer = styled('div', {
    minHeight: '$space$5',
    '@tablet': {
        minHeight: '$space$6'
    }
});
